import {
    makeApp, device, onReady, onError,
} from '@skeepers/platform-framework';

import { desktopRouter, mobileRouter } from './router';
import { makeStore } from './store';
import { CastingAPI } from './api';
import {
    API_URL, FRONT_PLAYER, EMBED_PLAYER, SENTRY_DSN, FRONT_CONNECT, MEDIAINFO_URL,
} from './config';

const api = new CastingAPI('platform-casting', API_URL);
const store = makeStore({ api });
const router = device.isDesktop ? desktopRouter : mobileRouter;
const getHome = (progress) => {
    if (progress === 'TYPEFORM') {
        return 'deposit';
    } else if (progress === 'UPLOAD') {
        return 'deposit.complete';
    } else {
        return 'brief';
    }
};

// Preserve query parameters if not overriden
// router.beforeEach((to, from, next) => {
//     if (Object.keys(to.query).length === 0 && Object.keys(from.query).length > 0) {
//         next({
//             ...to,
//             query: from.query,
//         });
//     } else {
//         next();
//     }
// });

makeApp({
    name: 'Casting',
    api,
    sentryDsn: SENTRY_DSN,
    playerEmbedUrl: EMBED_PLAYER,
    playerFrontUrl: FRONT_PLAYER,
    connectFrontUrl: FRONT_CONNECT,
    mediainfoUrl: MEDIAINFO_URL,
    router,
    store,
    home: '/',
    forbidden: '/forbidden',
    welcome () {
        return {
            name: getHome(store.state.casting.application?.progress),
        };
    },
    async onSetupUser (user) {
        await store.dispatch('ensureApplication');
    },
    onLogin () {
        router.push({ name: getHome(store.state.casting.application?.progress) });
    },
    onUpload (project) {
        store.dispatch('updateProgress', 'UPLOAD');
        store.dispatch('linkProject', project);
    },
    uploadOptions: {
        validTypes: ['VIDEO'],
        multiple: true,
    },
}).then(onReady).catch(onError);
